import { render, staticRenderFns } from "./ListTariffPage.vue?vue&type=template&id=293be1d6&"
import script from "./ListTariffPage.vue?vue&type=script&lang=js&"
export * from "./ListTariffPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports